<div class="d-flex justify-content-between">
  <div class="col-md-6 col-lg-6">
    <div class="locations-header loc">Top cash out locations</div>
    <div class="table-responsive">
      <table class="table">
        <th>Name</th>
        <th>Address</th>
        <th class="text-right">Currency</th>
        <th class="text-right">Amount</th>
        <tr *ngFor="let col of TOP_CASH_OUTS_LOCATIONS">
          <td>{{ col.name }}</td>
          <td>{{ col.address }}</td>
          <td class="text-right">
            {{ col.currency }}
          </td>
          <td class="text-right">
            <span style="color: #44546a">
              {{ col.cashoutSum | number : "1.2-2" }}</span
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="col-md-6 col-lg-6">
    <div class="locations-header loc">Top payment locations</div>
    <div class="table-responsive">
      <table class="table">
        <th>Name</th>
        <th>Address</th>
        <th class="text-right">Currency</th>
        <th class="text-right">Amount</th>
        <tr *ngFor="let col of TOP_PAYMENTS_LOCATIONS">
          <td>{{ col.name }}</td>
          <td>{{ col.address }}</td>
          <td class="text-right">
            {{ col.currency }}
          </td>
          <td class="text-right">
            <span style="color: #44546a">
              {{ col.paymentSum | number : "1.2-2" }}</span
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
